import { useEffect } from 'react';
import { useStore } from '~/store';

export function useAnimationLoop(frameCount: number, fps: number) {
  const isPlaying = useStore((s) => s.animation.isPlaying);
  const setCurrentFrame = useStore((s) => s.setCurrentFrame);

  useEffect(() => {
    if (!isPlaying || frameCount === 0) return;
    const id = window.setInterval(() => {
      const next = (useStore.getState().animation.currentFrame + 1) % frameCount;
      setCurrentFrame(next);
    }, 1000 / Math.max(1, fps));
    return () => window.clearInterval(id);
  }, [isPlaying, fps, frameCount, setCurrentFrame]);
}
